var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Loading',{attrs:{"id":"appLoading","is-show":_vm.$store.state.isAppLoad}}),(
            this.$route.name != 'consent' &&
            this.$route.name != 'terms' &&
            this.$route.name != 'sso' &&
            this.$route.name != 'otpSso' &&
            this.$route.name != 'register' &&
            this.$route.name != 'linelogin' &&
            this.$route.name != 'reconsent' &&
            this.$route.name != 'maintenance'
        )?_c('Concent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }